//@sample-repo
import Vue from 'vue'

const url = Vue.prototype.$config.api_url +'test'

const kanoon = {
  create(payload:any) {
  },
  edit(id:string|number,payload:any) {

  },
  find(id:string|number) {

  },
  delete(id:string|number) {

  },
  list(params = {}) {
  }
}

export default kanoon;

